// extracted by mini-css-extract-plugin
export default {"comments-block":"CommentsBlockPreview_comments-block__aLUmp","comments-block-date-text":"CommentsBlockPreview_comments-block-date-text__-W6ni"};